import React, { useEffect, useCallback, useState } from 'react';
import './PropertyUploadSuccessModal.css';

const CASHBACK_REDEEM_URL = 'https://forms.gle/6UBRpCFC48jnpnLZ6';

const SPARKLE_POSITIONS = [
  { top: '8%', left: '12%', delay: '0s' },
  { top: '14%', right: '18%', delay: '0.4s' },
  { top: '42%', left: '6%', delay: '0.8s' },
  { top: '55%', right: '8%', delay: '0.2s' },
  { top: '72%', left: '20%', delay: '1s' },
  { top: '78%', right: '22%', delay: '0.6s' },
];

const PropertyUploadSuccessModal = ({ isOpen, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleCancel = useCallback(() => {
    setIsAnimating(false);
    setTimeout(() => onClose(), 220);
  }, [onClose]);

  const handleRedeemNow = useCallback(() => {
    onClose();
    window.open(CASHBACK_REDEEM_URL, '_blank', 'noopener,noreferrer');
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) {
      setIsAnimating(false);
      return undefined;
    }

    const frame = requestAnimationFrame(() => setIsAnimating(true));
    return () => cancelAnimationFrame(frame);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleCancel();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, handleCancel]);

  if (!isOpen) return null;

  return (
    <div
      className={`property-upload-success-overlay ${isAnimating ? 'property-upload-success-visible' : 'property-upload-success-hidden'}`}
      onClick={handleCancel}
      role="presentation"
    >
      <div
        className="property-upload-success-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="property-upload-success-title"
      >
        <div className="property-upload-success-sparkles" aria-hidden="true">
          {SPARKLE_POSITIONS.map((pos, index) => (
            <span
              key={index}
              className="property-upload-success-sparkle"
              style={{
                top: pos.top,
                left: pos.left,
                right: pos.right,
                animationDelay: pos.delay,
              }}
            />
          ))}
        </div>

        <button
          type="button"
          className="property-upload-success-close"
          onClick={handleCancel}
          aria-label="Close"
        >
          ×
        </button>

        <div className="property-upload-success-ribbon">Cash Unlocked</div>

        <div className="property-upload-success-check-wrap">
          <span className="property-upload-success-check">✓</span>
        </div>

        <h2 id="property-upload-success-title" className="property-upload-success-title">
          Your property added successfully
        </h2>

        <div className="property-upload-success-badge-wrap">
          <div className="property-upload-success-badge">
            <span className="property-upload-success-badge-amount">10 rs</span>
          </div>
          <span className="property-upload-success-badge-label">Cash earned</span>
        </div>

        <p className="property-upload-success-message">
          Congratulations! You got <strong>₹10 cash</strong> on your property post.
          Redeem now to claim your reward.
        </p>

        <div className="property-upload-success-actions">
          <button
            type="button"
            className="property-upload-success-btn property-upload-success-btn--primary"
            onClick={handleRedeemNow}
          >
            Redeem Now
          </button>
          <button
            type="button"
            className="property-upload-success-btn property-upload-success-btn--ghost"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyUploadSuccessModal;
